export default __webpack_public_path__ + "static/media/tooltip-icon.98d2228a.svg";